import Fota from '@leverege/api-ui-fota-management';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
const objectType = Fota.Constants.Types.deviceGroup;
function getWithCounters(data, cxt) {
  const {
    deviceType
  } = cxt;
  const groupDelegate = DataSources.getActions({
    type: objectType,
    ref: '/deviceGroup'
  });
  const list = groupDelegate.getList(GlobalState.get(), {
    queryName: `${deviceType.id}/${data.id}`
  });
  const deviceGroup = list?.items?.[0];
  return groupDelegate.item(deviceGroup?.id).getItem(GlobalState.get(), {
    queryName: `${deviceType.id}/${data.id}/counters`
  });
}
async function loadWithCounters(data, cxt) {
  const {
    deviceType
  } = cxt;
  const groupDelegate = DataSources.getActions({
    type: objectType,
    ref: '/deviceGroup'
  });
  const list = groupDelegate.getList(GlobalState.get(), {
    queryName: `${deviceType.id}/${data.id}`
  });
  let deviceGroup = list?.items?.[0];
  const withCounters = groupDelegate.item(deviceGroup?.id).getItem(GlobalState.get(), {
    queryName: `${deviceType.id}/${data.id}/counters`
  });
  if (!deviceGroup || !withCounters) {
    try {
      if (!deviceGroup) {
        const nList = await GlobalState.dispatch(groupDelegate.list({
          deviceTypeId: deviceType.id,
          imagineGroupId: data.id
        }, {
          queryName: `${deviceType.id}/${data.id}`
        }));
        deviceGroup = nList?.items?.[0];
      }
      if (deviceGroup && !withCounters) {
        await GlobalState.dispatch(groupDelegate.item(deviceGroup?.id).get({
          includeCounters: true
        }, {
          queryName: `${deviceType.id}/${data.id}/counters`
        }));
      }
    } catch (err) {
      // do nothing
    }
  }
}
export default {
  getWithCounters,
  loadWithCounters
};